// This file can be replaced during build by using the fileReplacements array.
// ng build --prod replaces environment.ts with environment.prod.ts.
// The list of file replacements can be found in angular.json.
// let abc = "http://103.92.47.69";

class abc {
  static get baseUrl(): string {
    // Safety check for Server-Side Rendering (SSR) / Node.js
    if (typeof window === 'undefined') {
      return 'http://103.92.47.69';
    }

    const { protocol, hostname, port } = window.location;

    // A. Local Development
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://103.92.47.69';
    }

    // B. Live Server / Dynamic Domain or IP
    let dynamicUrl = `${protocol}//${hostname}`;

    if (port && port !== '80' && port !== '443') {
      dynamicUrl += `:${port}`;
    }

    return `${dynamicUrl}`;
  }
}
export const environment = {
  production: true,

  // Development Server Inhouse .
  // ----------------------------
  // appVersion: '5.0.0',
  // configUrl: '/hitechErp/Configuration',
  // apiUrl: '/hitechErp/Api/Coreapi',
  // invapiUrl: '/hitechErp/Api/inventory_management',
  // patapiUrl: '/hitechErp/Api/patients_care',
  // PateintbillingUrl: '/hitechErp/Api/patients_care/Billing',
  // accountingUrl: '/hitechErp/Api/Accounting',
  // officeadminUrl: '/hitechErp/Api/Office&Admin',
  // Prpo: '/hitechErp/Api/Prpo',
  // // Image Url
  // EmpImg: '/hitechErp/Upload/Employee_Regestration/',
  // legalEntityImg: '/hitechErp/Upload/LegalEntity/',
  // BoardTrusteeImg: '/hitechErp/Upload/board_trustess/',
  // OutsiderProf: '/hitechErp/Upload/outsider_prof/',
  // empnimage: '/hitechErp/Upload/Empn_patient/MLC_Upload/',
  // empnDignosticimage: '/hitechErp/Upload/Empn_patient/Dignostic_report/',
  // empntreatmentimage: '/hitechErp/Upload/Empn_patient/Treatment_Status/',
  // opdDignosticimage: '/hitechErp/Upload/Opd_Patient/Dignostic_report/',
  // PrpoImage: '/hitechErp/Upload/PrPo/QuotationInput/',
  // IpdConsentform : '/hitechErp/Upload/Ipd_Patient/Consent_Form/',
  // IpdClinicalRecord : '/hitechErp/Upload/Ipd_Patient/ClinicalRecord/',
  // IpdDischarge : '/hitechErp/Upload/Ipd_Patient/Discharge_Form/',
  // IpdTreatmentUpload : '/hitechErp/Upload/Ipd_Patient/Ipd_Dignostic_Report/',
  // IpdTreatmentStatus : '/hitechErp/Upload/Ipd_Patient/Ipd_treatmentstatus/',
  // // Dependancy Data
  // Emergency_deptId : 13,
  // Icu_deptId : 91

  // //working environment lasteste  New




    
appVersion: "5.0.0",
  configUrl: `${ abc.baseUrl}/dev/Configuration`,
  apiUrl: `${abc.baseUrl}/dev/Api/Coreapi`,
  invapiUrl: `${abc.baseUrl}/dev/Api/inventory_management`,
  patapiUrl: `${abc.baseUrl}/dev/Api/patients_care`,
  PateintbillingUrl: `${abc.baseUrl}/dev/Api/patients_care/Billing`,
  accountingUrl: `${abc.baseUrl}/dev/Api/Accounting`,
  officeadminUrl: `${abc.baseUrl}/dev/Api/Office&Admin`,
      dashboardApiUrl: `${abc.baseUrl}/dev/Api/dashboard`,

    Prpo: `${abc.baseUrl}/dev/Api/Prpo`,
  //Image Url
  EmpImg: `${abc.baseUrl}/dev/Upload/Employee_Regestration/`,
  legalEntityImg: `${abc.baseUrl}/dev/Upload/LegalEntity/`,
  BoardTrusteeImg: `${abc.baseUrl}/dev/Upload/board_trustess/`,
  OutsiderProf: `${abc.baseUrl}/dev/Upload/outsider_professional/`,
  empnimage: `${abc.baseUrl}/dev/Upload/Empn_patient/MLC_Upload/`,
  ipnimage: `${abc.baseUrl}/dev/Upload/Ipd_Patient/Mlc_Upload/`,

  empnDignosticimage: `${abc.baseUrl}/dev/Upload/Empn_patient/Dignostic_report/`,
  empntreatmentimage: `${abc.baseUrl}/dev/Upload/Empn_patient/Treatment_Status/`,
  opdDignosticimage: `${abc.baseUrl}/dev/Upload/Opd_Patient/Dignostic_report/`,
  PrpoImage: `${abc.baseUrl}/dev/Upload/PrPo/QuotationInput/`,
  IpdConsentform: `${abc.baseUrl}/dev/Upload/Ipd_Patient/Consent_Form/`,
  IpdClinicalRecord: `${abc.baseUrl}/dev/Upload/Ipd_Patient/ClinicalRecord/`,
  IpdDischarge: `${abc.baseUrl}/dev/Upload/Ipd_Patient/Discharge_Form/`,
  IpdTreatmentUpload: `${abc.baseUrl}/dev/Upload/Ipd_Patient/Ipd_Dignostic_Report/`,
  IpdTreatmentStatus: `${abc.baseUrl}/dev/Upload/Ipd_Patient/Ipd_treatmentstatus/`,

  IpdPreOtProcess: `${abc.baseUrl}/dev/Upload/Ipd_Patient/Per_OT_Process/`,
  DuringOtProcess: `${abc.baseUrl}/dev/Upload/Ipd_Patient/During_Ot_Process/`,
  PostOtProcess: `${abc.baseUrl}/dev/Upload/Ipd_Patient/Post_OT_Process/`,

  IpdFinalDischarge: `${abc.baseUrl}/dev/Upload/Ipd_Patient/Actual_Discharge/`,
  patientBloodGroupImage: `${abc.baseUrl}/dev/Upload/Patient_Details/`,

  opdOtherTicket: `${abc.baseUrl}/dev/Upload/Opd_Patient/Opd_OtherTicket`,
  OpdIpAdmission: `${abc.baseUrl}/dev/Upload/Opd_Patient/Op_Ip_Admission`,

  EmpnMinorOtProcess: `${abc.baseUrl}/dev/Upload/Empn_patient/Empn_Minor_Ot/`,
  EmpnPostOtProcess: `${abc.baseUrl}/dev/Upload/Empn_patient/Empn_Post_Ot/`,
  EmpnDischargeNoteUpload: `${abc.baseUrl}/dev/Upload/Empn_patient/Dischargeadvice/`,

  EmpnInitiatedischarge: `${abc.baseUrl}/dev/Upload/Empn_patient/Initiatedischarge/`,

  EMPNDischarge: `${abc.baseUrl}/dev/Upload/Empn_patient/EmpnActualDischarge/`,
  EmpnMRD: `${abc.baseUrl}/dev/Upload/Ipd_Patient/MrdProcess/`,
  MRDotherDoc: `${abc.baseUrl}/dev/Upload/Ipd_Patient/MrdProcessFinal/`,

  OPDMinorProcess: `${abc.baseUrl}/dev/Upload/Opd_patient/opd_Minor_Ot/`,
  GovtBilling: `${abc.baseUrl}/dev/Upload/All_Billing/Bsky_Billing/`,
  CorporateBilling: `${abc.baseUrl}/dev/Upload/All_Billing/Corp_Billing/`,

  uploadPath: `${abc.baseUrl}/dev/Upload/`,
  RfqNotification: `${abc.baseUrl}/dev/Upload/PrPo/RfqNotification/`,
  otherPayables: `${abc.baseUrl}/dev/Upload/Accounting/Billprocess`,

  RateContactFilePath: `${abc.baseUrl}/dev/Upload/PrPo/QuotationFileName/`,
  agrementDownloadPath: `${abc.baseUrl}/dev/Upload/PrPo/Rcaggreement/`,

  InsuranceDoc: `${abc.baseUrl}/dev/Upload/All_Billing/Insurance_Billing/`,
  MembershipCardDoc: `${abc.baseUrl}/dev/Upload/PrivilegeMembershipCard/`,
  baseSocketUrl: "http://139.59.59.4:5999",
  // PharmacyUrl: "http://103.39.240.107/pharmacyAPI/api",
    PharmacyUrl: `${abc.baseUrl}/pharmacyAPI/api`,

 Dothealth: `${abc.baseUrl}/dev/Api/HimsV2`,

  Dothealthdoc: `${abc.baseUrl}/dev/Upload/Dothealth/Reportfile/`,

  HRMSUpload: `${abc.baseUrl}/dev/Upload/HRMS/TourAdvance/TourBillSubmission/`,
  HRMStouradvanceUpload: `${abc.baseUrl}/dev/Upload/HRMS/TourAdvance/`,

  poDocumentBasePath: `${abc.baseUrl}/dev/Upload/PrPo/PoSpecDoc`,

  Dignosticdoc: `${abc.baseUrl}/dev/Upload/Dignosticdoc/`,
  baseFileUrl: `${abc.baseUrl}/`,
  //Dependancy Data
  Emergency_deptId: 13,
  Icu_deptId: 91,


  // //working environment New
  // appVersion: "5.0.0",
  // poDocumentBasePath: "https://pamoxdev.pro/hitechErp/Upload/PrPo/PoSpecDoc",
  // configUrl: "https://pamoxdev.pro/hitechErp/Configuration",
  // apiUrl: "https://pamoxdev.pro/hitechErp/Api/Coreapi", 
  //  dashboardApiUrl: "https://pamoxdev.pro/hitechErp/Api/dashboard",

  // invapiUrl: "https://pamoxdev.pro/hitechErp/Api/inventory_management",
  // patapiUrl: "https://pamoxdev.pro/hitechErp/Api/patients_care",
  // PateintbillingUrl: "https://pamoxdev.pro/hitechErp/Api/patients_care/Billing",
  // accountingUrl: "https://pamoxdev.pro/hitechErp/Api/Accounting",
  // officeadminUrl: "https://pamoxdev.pro/hitechErp/Api/Office&Admin",
  // Prpo: "https://pamoxdev.pro/hitechErp/Api/Prpo",
  // // Image Url
  // EmpImg: "https://pamoxdev.pro/hitechErp/Upload/Employee_Regestration/",
  // legalEntityImg: "https://pamoxdev.pro/hitechErp/Upload/LegalEntity/",
  // BoardTrusteeImg: "https://pamoxdev.pro/hitechErp/Upload/board_trustess/",
  // OutsiderProf: "https://pamoxdev.pro/hitechErp/Upload/outsider_prof/",
  // empnimage: "https://pamoxdev.pro/hitechErp/Upload/Empn_patient/MLC_Upload/",
  // ipnimage: "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/Mlc_Upload/",
  // empnDignosticimage:
  //   "https://pamoxdev.pro/hitechErp/Upload/Empn_patient/Dignostic_report/",
  // empntreatmentimage:
  //   "https://pamoxdev.pro/hitechErp/Upload/Empn_patient/Treatment_Status/",
  // opdDignosticimage:
  //   "https://pamoxdev.pro/hitechErp/Upload/Opd_Patient/Dignostic_report/",
  // PrpoImage: "https://pamoxdev.pro/hitechErp/Upload/PrPo/QuotationInput/",
  // IpdConsentform:
  //   "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/Consent_Form/",
  // IpdClinicalRecord:
  //   "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/ClinicalRecord/",
  // IpdTreatmentUpload:
  //   "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/Ipd_Dignostic_Report/",
  // IpdTreatmentStatus:
  //   "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/Ipd_treatmentstatus/",

  // IpdPreOtProcess:
  //   "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/Per_OT_Process/",
  // DuringOtProcess:
  //   "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/During_Ot_Process/",
  // PostOtProcess:
  //   "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/Post_OT_Process/",

  // IpdDischarge:
  //   "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/Discharge_Form/",

  // EMPNDischarge:
  //   "https://pamoxdev.pro/hitechErp/Upload/Empn_patient/EmpnActualDischarge/",

  // IpdFinalDischarge:
  //   "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/Actual_Discharge/",
  // patientBloodGroupImage:
  //   "https://pamoxdev.pro/hitechErp/Upload/Patient_Details/",

  // opdOtherTicket:
  //   "https://pamoxdev.pro/hitechErp/Upload/Opd_Patient/Opd_OtherTicket",
  // OpdIpAdmission:
  //   "https://pamoxdev.pro/hitechErp/Upload/Opd_Patient/Op_Ip_Admission",

  // EmpnMinorOtProcess:
  //   "https://pamoxdev.pro/hitechErp/Upload/Empn_patient/Empn_Minor_Ot/",
  // EmpnPostOtProcess:
  //   "https://pamoxdev.pro/hitechErp/Upload/Empn_patient/Empn_Post_Ot/",
  // EmpnDischargeNoteUpload:
  //   "https://pamoxdev.pro/hitechErp/Upload/Empn_patient/Dischargeadvice/",
  // EmpnInitiatedischarge:
  //   "https://pamoxdev.pro/hitechErp/Upload/Empn_patient/Initiatedischarge/",

  // EmpnMRD: "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/MrdProcess/",
  // MRDotherDoc:
  //   "https://pamoxdev.pro/hitechErp/Upload/Ipd_Patient/MrdProcessFinal/",

  // OPDMinorProcess:
  //   "https://pamoxdev.pro/hitechErp/Upload/Opd_patient/opd_Minor_Ot/",
  // GovtBilling:
  //   "https://pamoxdev.pro/hitechErp/Upload/All_Billing/Bsky_Billing/",
  // CorporateBilling:
  //   "https://pamoxdev.pro/hitechErp/Upload/All_Billing/Corp_Billing/",
  // otherPayables: "https://pamoxdev.pro/hitechErp/Upload/Accounting/Billprocess",

  // //Extra path to add MRD Approval (Upload to QC if needed)
  // uploadPath: "https://pamoxdev.pro/hitechErp/Upload/",
  // RfqNotification:
  //   "https://pamoxdev.pro/hitechErp/Upload/PrPo/RfqNotification/",
  // RateContactFilePath:
  //   "https://pamoxdev.pro/hitechErp/Upload/PrPo/QuotationFileName/",
  // agrementDownloadPath:
  //   "https://pamoxdev.pro/hitechErp/Upload/PrPo/Rcaggreement/",
  // InsuranceDoc: "https://pamoxdev.pro/hitechErp/Upload/Insurance_Billing/",

  // baseSocketUrl: "https://socket.pamoxdev.pro",
  // //  PharmacyUrl: 'http://103.39.240.108/pharmacyAPI/api',
  // PharmacyUrl: "https://pamoxpp.pro/pharmacyAPI/api",

  // // Dothealth: 'http://103.39.240.108/dev/Api/HimsV2',
  // Dothealth: "https://pamoxdev.pro/hitechErp/Api/HimsV2",

  // // Dothealth1: 'http://103.39.240.108/dev/Api/Coreapi',

  // Dothealthdoc: "https://pamoxdev.pro/hitechErp/Upload/Dothealth/Reportfile/",
  // HRMSUpload:
  //   "https://pamoxdev.pro/hitechErp/Upload/HRMS/TourAdvance/TourBillSubmission/",
  // HRMStouradvanceUpload:
  //   "https://pamoxdev.pro/hitechErp/Upload/HRMS/TourAdvance/",

  // Dignosticdoc: "https://pamoxdev.pro/hitechErp/Upload/Dignosticdoc/",

  // baseFileUrl: "https://pamoxdev.pro/hitechErp/",
  // //Dependancy Data
  // Emergency_deptId: 13,
  // Icu_deptId: 91,

  // //working environment
  //  appVersion: '5.0.0',
  //   configUrl: 'http://103.92.47.69/hitechErp/Configuration',
  //   apiUrl: 'http://103.92.47.69/hitechErp/Api/Coreapi',
  //   invapiUrl: 'http://103.92.47.69/hitechErp/Api/inventory_management',
  //   patapiUrl: 'http://103.92.47.69/hitechErp/Api/patients_care',
  //   PateintbillingUrl: 'http://103.92.47.69/hitechErp/Api/patients_care/Billing',
  //   accountingUrl: 'http://103.92.47.69/hitechErp/Api/Accounting',
  //   officeadminUrl: 'http://103.92.47.69/hitechErp/Api/Office&Admin',
  //   Prpo: 'http://103.92.47.69/hitechErp/Api/Prpo',
  //   // Image Url
  //   EmpImg: 'http://103.92.47.69/hitechErp/Upload/Employee_Regestration/',
  //   legalEntityImg: 'http://103.92.47.69/hitechErp/Upload/LegalEntity/',
  //   BoardTrusteeImg: 'http://103.92.47.69/hitechErp/Upload/board_trustess/',
  //   OutsiderProf: 'http://103.92.47.69/hitechErp/Upload/outsider_prof/',
  //   empnimage: 'http://103.92.47.69/hitechErp/Upload/Empn_patient/MLC_Upload/',
  //   ipnimage: 'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/Mlc_Upload/',
  //   empnDignosticimage: 'http://103.92.47.69/hitechErp/Upload/Empn_patient/Dignostic_report/',
  //   empntreatmentimage: 'http://103.92.47.69/hitechErp/Upload/Empn_patient/Treatment_Status/',
  //   opdDignosticimage: 'http://103.92.47.69/hitechErp/Upload/Opd_Patient/Dignostic_report/',
  //   PrpoImage: 'http://103.92.47.69/hitechErp/Upload/PrPo/QuotationInput/',
  //   IpdConsentform : 'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/Consent_Form/',
  //   IpdClinicalRecord : 'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/ClinicalRecord/',
  //   IpdTreatmentUpload : 'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/Ipd_Dignostic_Report/',
  //   IpdTreatmentStatus : 'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/Ipd_treatmentstatus/',

  //   IpdPreOtProcess : 'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/Per_OT_Process/',
  //   DuringOtProcess : 'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/During_Ot_Process/',
  //   PostOtProcess : 'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/Post_OT_Process/',

  //   IpdDischarge : 'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/Discharge_Form/',

  //   EMPNDischarge : 'http://103.92.47.69/hitechErp/Upload/Empn_patient/EmpnActualDischarge/',

  //   IpdFinalDischarge : 'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/Actual_Discharge/',
  //   patientBloodGroupImage : 'http://103.92.47.69/hitechErp/Upload/Patient_Details/',

  //   opdOtherTicket : 'http://103.92.47.69/hitechErp/Upload/Opd_Patient/Opd_OtherTicket',
  //   OpdIpAdmission : 'http://103.92.47.69/hitechErp/Upload/Opd_Patient/Op_Ip_Admission' ,

  //   EmpnMinorOtProcess : 'http://103.92.47.69/hitechErp/Upload/Empn_patient/Empn_Minor_Ot/',
  //   EmpnPostOtProcess : 'http://103.92.47.69/hitechErp/Upload/Empn_patient/Empn_Post_Ot/',
  //   EmpnDischargeNoteUpload :'http://103.92.47.69/hitechErp/Upload/Empn_patient/Dischargeadvice/',
  //   EmpnInitiatedischarge :'http://103.92.47.69/hitechErp/Upload/Empn_patient/Initiatedischarge/',

  //   EmpnMRD :'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/MrdProcess/',
  //   MRDotherDoc :'http://103.92.47.69/hitechErp/Upload/Ipd_Patient/MrdProcessFinal/',

  //   OPDMinorProcess :'http://103.92.47.69/hitechErp/Upload/Opd_patient/opd_Minor_Ot/',
  //   GovtBilling :'http://103.92.47.69/hitechErp/Upload/All_Billing/Bsky_Billing/',
  //   CorporateBilling :'http://103.92.47.69/hitechErp/Upload/All_Billing/Corp_Billing/',
  //   otherPayables:'http://103.92.47.69/hitechErp/Upload/Accounting/Billprocess',

  //   //Extra path to add MRD Approval (Upload to QC if needed)
  //   uploadPath :'http://103.92.47.69/hitechErp/Upload/',
  //   RfqNotification : "http://103.92.47.69/hitechErp/Upload/PrPo/RfqNotification/",
  //   RateContactFilePath : "http://103.92.47.69/hitechErp/Upload/PrPo/QuotationFileName/",
  //   agrementDownloadPath :'http://103.92.47.69/hitechErp/Upload/PrPo/Rcaggreement/',
  //    InsuranceDoc : '../Upload/All_Billing/Insurance_Billing/',

  //     baseSocketUrl: 'http://72.60.221.213:5999',
  //     PharmacyUrl: 'http://103.39.240.108/pharmacyAPI/api',
  //     // Dothealth: 'http://103.39.240.108/dev/Api/HimsV2',
  //         Dothealth: 'http://103.92.47.69/hitechErp/Api/HimsV2',

  //       // Dothealth1: 'http://103.39.240.108/dev/Api/Coreapi',

  //           Dothealthdoc: 'http://103.92.47.69/hitechErp/Api/Upload/Dothealth/Reportfile/',

  //   //Dependancy Data
  //   Emergency_deptId : 13,
  //   Icu_deptId : 91

  // Quality Server Inhouse Staging.
  // ----------------------------------
  //   appVersion: '5.0.0',
  //   configUrl: '../Configuration',
  //   apiUrl: '../Api/Coreapi',
  //   invapiUrl: '../Api/inventory_management',
  //   patapiUrl: '../Api/patients_care',
  //   PateintbillingUrl: '../Api/patients_care/Billing',
  //   accountingUrl: '../Api/Accounting', 
  //   officeadminUrl: '../Api/Office&Admin',
  //  dashboardApiUrl: "../Api/dashboard",

  //   Prpo: '../Api/Prpo',
  //   // Image Url
  //   EmpImg: '../Upload/Employee_Regestration/',
  //   legalEntityImg: '../Upload/LegalEntity/',
  //   BoardTrusteeImg: '../Upload/board_trustess/',
  //   OutsiderProf: '../Upload/outsider_prof/',
  //   empnimage: '../Upload/Empn_patient/MLC_Upload/',
  //   ipnimage: '../Upload/Ipd_Patient/Mlc_Upload/',

  //   empnDignosticimage: '../Upload/Empn_patient/Dignostic_report/',
  //   empntreatmentimage: '../Upload/Empn_patient/Treatment_Status/',
  //   opdDignosticimage: '../Upload/Opd_Patient/Dignostic_report/',
  //   PrpoImage: '../Upload/PrPo/QuotationInput/',
  //   IpdConsentform : '../Upload/Ipd_Patient/Consent_Form/',
  //   IpdClinicalRecord : '../Upload/Ipd_Patient/ClinicalRecord/',
  //   IpdDischarge : '../Upload/Ipd_Patient/Discharge_Form/',
  //    IpdTreatmentUpload : '../Upload/Ipd_Patient/Ipd_Dignostic_Report/',
  //   IpdTreatmentStatus : '../Upload/Ipd_Patient/Ipd_treatmentstatus/',

  //   IpdPreOtProcess : '../Upload/Ipd_Patient/Per_OT_Process/',
  //   DuringOtProcess : '../Upload/Ipd_Patient/During_Ot_Process/',
  //   PostOtProcess : '../Upload/Ipd_Patient/Post_OT_Process/',

  //   IpdFinalDischarge : '../Upload/Ipd_Patient/Actual_Discharge/',
  //   patientBloodGroupImage : '../Upload/Patient_Details/',

  //   opdOtherTicket : '../Upload/Opd_Patient/Opd_OtherTicket',
  //   OpdIpAdmission : '../Upload/Opd_Patient/Op_Ip_Admission',

  //   EmpnMinorOtProcess : '../Upload/Empn_patient/Empn_Minor_Ot/',
  //   EmpnPostOtProcess : '../Upload/Empn_patient/Empn_Post_Ot/',
  //   EmpnDischargeNoteUpload :'../Upload/Empn_patient/Dischargeadvice/',
  //   EMPNDischarge : '../Upload/Empn_patient/EmpnActualDischarge/',
  //    EmpnMRD :'../Upload/Ipd_Patient/MrdProcess/',
  //   MRDotherDoc :'../Upload/Ipd_Patient/MrdProcessFinal/',
  //    otherPayables:'../Upload/Accounting/Billprocess',

  //    OPDMinorProcess :'../Upload/Opd_patient/opd_Minor_Ot/',
  //     GovtBilling :'../Upload/All_Billing/Bsky_Billing/',
  //  CorporateBilling : '../Upload/All_Billing/Corp_Billing/',

  //   uploadPath :'../Upload/',
  //    RfqNotification : "../Upload/PrPo/RfqNotification/",
  //   EmpnInitiatedischarge :'../Upload/Empn_patient/Initiatedischarge/',

  //   RateContactFilePath : "../Upload/PrPo/QuotationFileName/",
  //   agrementDownloadPath :'../Upload/PrPo/Rcaggreement/',
  //   InsuranceDoc : '../Upload/Insurance_Billing/',
  //   baseSocketUrl: 'http://72.60.221.213:5999',
  //     PharmacyUrl: 'http://103.39.240.108/pharmacyAPI/api',
  //    Dothealth: '../Api/HimsV2',
  //    Dothealthdoc: '../Upload/Dothealth/Reportfile/',

  // HRMSUpload: "../Upload/HRMS/TourAdvance/TourBillSubmission/",
  // HRMStouradvanceUpload: "../Upload/HRMS/TourAdvance/",

  // Dignosticdoc: "../Upload/Dignosticdoc/",

  // baseFileUrl: "https://pamoxdev.pro/hitechErp/",
  // poDocumentBasePath: '../Upload/PrPo/PoSpecDoc',

  //   // Dependancy Data
  //   Emergency_deptId : 13,
  //   Icu_deptId : 91

  // / Quality New Server Inhouse Staging.
  // // ----------------------------------
  // appVersion: '5.0.0',

  // configUrl: 'http://172.15.1.242/qc/Configuration',
  //  apiUrl: 'http://172.15.1.242/qc/Api/Coreapi',
  //  invapiUrl: 'http://172.15.1.242/qc/Api/inventory_management',
  //  patapiUrl: 'http://172.15.1.242/qc/Api/patients_care',
  //  PateintbillingUrl: 'http://172.15.1.242/qc/Api/patients_care/Billing',
  //  accountingUrl: 'http://172.15.1.242/qc/Api/Accounting',
  //  officeadminUrl: 'http://172.15.1.242/qc/Api/Office&Admin',
  //  Prpo: 'http://172.15.1.242/qc/Api/Prpo',
  //  // Image Url
  //  EmpImg: 'http://172.15.1.242/qc/Upload/Employee_Regestration/',
  //  legalEntityImg: 'http://172.15.1.242/qc/Upload/LegalEntity/',
  //  BoardTrusteeImg: 'http://172.15.1.242/qc/Upload/board_trustess/',
  //  OutsiderProf: 'http://172.15.1.242/qc/Upload/outsider_prof/',
  //  empnimage: 'http://172.15.1.242/qc/Upload/Empn_patient/MLC_Upload/',
  //  empnDignosticimage: 'http://172.15.1.242/qc/Upload/Empn_patient/Dignostic_report/',
  //  empntreatmentimage: 'http://172.15.1.242/qc/Upload/Empn_patient/Treatment_Status/',

  //  opdDignosticimage: 'http://172.15.1.242/qc/Upload/Opd_Patient/Dignostic_report/',
  //  PrpoImage: 'http://172.15.1.242/qc/Upload/PrPo/QuotationInput/',

  //  IpdConsentform : 'http://172.15.1.242/qc/Upload/Ipd_Patient/Consent_Form/',
  //  IpdClinicalRecord : 'http://172.15.1.242/qc/Upload/Ipd_Patient/ClinicalRecord/',
  //  IpdTreatmentUpload : 'http://172.15.1.242/qc/Upload/Ipd_Patient/Ipd_Dignostic_Report/',
  //  IpdTreatmentStatus : 'http://172.15.1.242/qc/Upload/Ipd_Patient/Ipd_treatmentstatus/',

  //  IpdPreOtProcess : 'http://172.15.1.242/qc/Upload/Ipd_Patient/Per_OT_Process/',
  //  DuringOtProcess : 'http://172.15.1.242/qc/Upload/Ipd_Patient/During_Ot_Process/',
  //  PostOtProcess : 'http://172.15.1.242/qc/Upload/Ipd_Patient/Post_Ot_Process/',

  //  IpdDischarge : 'http://172.15.1.242/qc/Upload/Ipd_Patient/Discharge_Form/',

  //  IpdFinalDischarge : 'http://172.15.1.242/qc/Upload/Ipd_Patient/Actual_Discharge/',
  //  patientBloodGroupImage : 'http://172.15.1.242/qc/Upload/Patient_Details/',

  //  opdOtherTicket : 'http://172.15.1.242/qc/Upload/Opd_Patient/Opd_OtherTicket',
  //  OpdIpAdmission : 'http://172.15.1.242/qc/Upload/Opd_Patient/Op_Ip_Admission' ,

  //  EmpnMinorOtProcess : 'http://172.15.1.242/qc/Upload/Empn_patient/Empn_Minor_Ot/',
  //  EmpnPostOtProcess : 'http://172.15.1.242/qc/Upload/Empn_patient/Empn_Post_Ot/',
  //  EmpnDischargeNoteUpload :'http://172.15.1.242/qc/Upload/Empn_patient/Dischargeadvice/',

  //    EMPNDischarge : 'http://172.15.1.242/qc/Upload/Empn_patient/EmpnActualDischarge/',

  // uploadPath :'http://172.15.1.242/qc/Upload/',
  //  RfqNotification : "http://172.15.1.242/qc/Upload/PrPo/RfqNotification/",
  // EmpnInitiatedischarge :'http://172.15.1.242/qc/Upload/Empn_patient/Initiatedischarge/',

  // RateContactFilePath : "http://172.15.1.242/qc/Upload/PrPo/QuotationFileName/",
  // agrementDownloadPath :'http://172.15.1.242/qc/Upload/PrPo/Rcaggreement/',
  //  //Dependancy Data
  //  Emergency_deptId : 13,
  //  Icu_deptId : 91
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as zone.run, zoneDelegate.invokeTask.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
